"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackLink = exports.BackButton = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const icons_1 = require("../../../icons/icons");
const BackButton = ({ onClick, disabled, asLink }) => {
    return (react_1.default.createElement("button", { onClick: onClick, disabled: disabled, role: asLink ? 'link' : undefined, className: "flex h-5 w-5 items-center justify-center rounded text-grey-4 hover:opacity-80 focus:outline-none focus:ring focus:ring-blue-4/40 disabled:opacity-40" }, icons_1.SVG_FULL_ARROW_LEFT));
};
exports.BackButton = BackButton;
const BackLink = ({ to }) => {
    return (react_1.default.createElement(react_router_dom_1.Link, { to: to, className: "flex h-5 w-5 items-center justify-center rounded text-grey-4 hover:opacity-80 focus:ring-blue-4/40 disabled:opacity-40" }, icons_1.SVG_FULL_ARROW_LEFT));
};
exports.BackLink = BackLink;
